import axios from 'axios';
import { AUTH_ENDPOINTS, SSO_API_BASE_URL } from './endpoints';
import { TOKEN_TYPE, getTokenFromCookies, clearAllTokens } from '../../../lib/cookies';
import { getRootDomain } from '../../../lib/domain';

function clearStoredTokens(): void {
  const root = getRootDomain(window.location.hostname);
  const domain = root ? `.${root}` : undefined;
  clearAllTokens(domain);
  clearAllTokens();
}

const authAxios = axios.create({
  baseURL: SSO_API_BASE_URL,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

authAxios.interceptors.request.use((config) => {
  const token = getTokenFromCookies(TOKEN_TYPE.ACCESS_TOKEN);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

authAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && getTokenFromCookies(TOKEN_TYPE.ACCESS_TOKEN)) {
      clearStoredTokens();
    }
    return Promise.reject(error);
  },
);

export const authAPI = {
  login: async (email: string, password: string) =>
    (await authAxios.post(AUTH_ENDPOINTS.login, { email, password })).data,

  register: async (email: string, password: string, displayName: string) =>
    (await authAxios.post(AUTH_ENDPOINTS.register, {
      email,
      password,
      display_name: displayName,
    })).data,

  verifyEmail: async (email: string, otp: string) =>
    (await authAxios.post(AUTH_ENDPOINTS.verifyEmail, { email, otp })).data,

  resendVerification: async (email: string) =>
    (await authAxios.post(AUTH_ENDPOINTS.resendVerification, { email })).data,

  totpVerify: async (email: string, password: string, code: string) =>
    (await authAxios.post(AUTH_ENDPOINTS.totpVerify, { email, password, code })).data,

  refreshToken: async (refresh_token: string) =>
    (await authAxios.post(AUTH_ENDPOINTS.refresh, { refresh_token })).data,

  me: async () => (await authAxios.get(AUTH_ENDPOINTS.me)).data,

  logout: async () => (await authAxios.post(AUTH_ENDPOINTS.logout)).data,

  googleLogin: async (params: { accessToken?: string; idToken?: string }) =>
    (await authAxios.post(AUTH_ENDPOINTS.google, params)).data,
};
